import { Clock } from 'lucide-react'
import { CollapsibleSection } from '../shared/CollapsibleSection'
import type { FunnelVersion } from '../../types'

interface VersionHistoryProps {
  versions: FunnelVersion[]
  loading: boolean
}

export function VersionHistory({ versions, loading }: VersionHistoryProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date)
  }

  return (
    <CollapsibleSection
      title="Version History"
      defaultOpen={false}
      badge={
        versions.length > 0 && (
          <span
            className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium text-fn-text-sub"
            style={{
              backgroundColor: 'var(--fn-bg-muted)',
            }}
          >
            {versions.length}
          </span>
        )
      }
    >
      {loading ? (
        <p className="text-sm py-4 text-center text-fn-text-muted">
          Loading history...
        </p>
      ) : versions.length === 0 ? (
        <p className="text-sm py-4 text-center text-fn-text-muted">
          No version history available
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-fn-border">
                <th className="text-left py-2 px-2 font-medium text-fn-text-sub">
                  Version
                </th>
                <th className="text-left py-2 px-2 font-medium text-fn-text-sub">
                  Action
                </th>
                <th className="text-left py-2 px-2 font-medium text-fn-text-sub">
                  Actor
                </th>
                <th className="text-left py-2 px-2 font-medium text-fn-text-sub">
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {versions.map((version) => (
                <tr
                  key={version.id}
                  className="border-b border-fn-border hover:bg-fn-hover animate-fade-slide-in"
                >
                  <td className="py-2 px-2 text-fn-text">
                    v{version.version}
                  </td>
                  <td className="py-2 px-2 text-fn-text">
                    {version.action}
                  </td>
                  <td className="py-2 px-2 text-fn-text-sub">
                    {version.actor}
                  </td>
                  <td className="py-2 px-2 flex items-center gap-1 text-fn-text-muted">
                    <Clock className="w-3 h-3" />
                    {formatDate(version.createdAt)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </CollapsibleSection>
  )
}
